(function () {
  var SKIP_LABEL = 'Skip and send later';
  var APPLY_DELAYS = [0, 50, 150, 400, 800];
  var STYLE_ID = 'ciw-la-contact-submission-styles';

  function pinSubmissionStylesLast() {
    var styleEl = document.getElementById(STYLE_ID);
    if (!styleEl || !styleEl.parentNode) return;
    if (styleEl !== document.body.lastElementChild) {
      document.body.appendChild(styleEl);
    }
  }

  function schedulePinStyles() {
    pinSubmissionStylesLast();
    [0, 100, 400, 800, 1000, 1200].forEach(function (delay) {
      window.setTimeout(pinSubmissionStylesLast, delay);
    });
  }

  function isContactHost() {
    return window.ciwLaHostApi ? window.ciwLaHostApi.isContactLens() : !!document.querySelector('.cl-section');
  }

  function getSubmissionScope() {
    return document.querySelector('.la-prescription-wrapper:not(form)');
  }

  function getWrapperTitleText(wrapper) {
    if (!wrapper) return '';
    var titleEl = wrapper.querySelector('.la-label-title');
    if (!titleEl) return '';
    var translate = titleEl.querySelector('la-translate');
    return (translate ? translate.textContent : titleEl.textContent).trim();
  }

  function setWrapperTitleText(wrapper, text) {
    if (!wrapper) return;
    var titleEl = wrapper.querySelector('.la-label-title');
    if (!titleEl) return;
    var translate = titleEl.querySelector('la-translate');
    if (translate) {
      translate.textContent = text;
    } else {
      titleEl.textContent = text;
    }
  }

  function getSubmissionWrappers(scope) {
    var seen = [];
    var selectors = [
      '.la-label-btn-wrapper.la-submission-method',
      '.la-horizontal-boxy-label-wrapper'
    ];

    selectors.forEach(function (selector) {
      scope.querySelectorAll(selector).forEach(function (wrapper) {
        if (seen.indexOf(wrapper) !== -1) return;
        if (!wrapper.querySelector('input[type="radio"]')) return;
        seen.push(wrapper);
      });
    });

    return seen;
  }

  function isOnFileWrapper(wrapper) {
    return /prescription on file|rx on file|on file/i.test(getWrapperTitleText(wrapper));
  }

  function isEmailLaterWrapper(wrapper) {
    if (wrapper.classList.contains('ciw-la-contact-skip-link')) return true;
    var radio = wrapper.querySelector('input[type="radio"]');
    if (radio) {
      var id = String(radio.id || '').toLowerCase();
      var name = String(radio.name || '').toLowerCase();
      var value = String(radio.value || '').toLowerCase();
      if (/email.?later|send.?later|later/.test(id + ' ' + value)) return true;
      if (radio.matches && radio.matches('[data-submission-type="email"], [data-submission-type="later"], .la-submission-type-email, .la-submission-type-later')) {
        return true;
      }
    }
    return /email later|emailing it later|send prescription later|send later/i.test(getWrapperTitleText(wrapper));
  }

  function isManualWrapper(wrapper) {
    return /enter manually|manual entry|fill manually|manual/i.test(getWrapperTitleText(wrapper));
  }

  function findManualWrapper(wrappers) {
    for (var i = 0; i < wrappers.length; i++) {
      if (isManualWrapper(wrappers[i])) return wrappers[i];
    }

    var cards = wrappers.filter(function (wrapper) {
      return (
        !wrapper.classList.contains('ciw-la-submission-on-file-hidden') &&
        !wrapper.classList.contains('ciw-la-contact-skip-link')
      );
    });

    return cards[1] || null;
  }

  function customizeContactSubmissionMethods() {
    if (!isContactHost() || !document.body.classList.contains('la-modal-open')) return;

    var scope = getSubmissionScope();
    if (!scope) return;

    var wrappers = getSubmissionWrappers(scope);
    if (!wrappers.length) return;

    var onFileWrapper = null;
    var skipWrapper = null;

    wrappers.forEach(function (wrapper) {
      if (isOnFileWrapper(wrapper)) onFileWrapper = wrapper;
      if (isEmailLaterWrapper(wrapper)) skipWrapper = wrapper;
    });

    if (onFileWrapper) {
      onFileWrapper.classList.add('ciw-la-submission-on-file-hidden');
    }

    if (!skipWrapper) return;

    skipWrapper.classList.add('ciw-la-contact-skip-link');
    setWrapperTitleText(skipWrapper, SKIP_LABEL);

    var anchor = findManualWrapper(wrappers);
    if (anchor && skipWrapper.parentElement) {
      if (anchor.nextElementSibling !== skipWrapper) {
        anchor.insertAdjacentElement('afterend', skipWrapper);
      }
    }
  }

  function scheduleCustomize() {
    customizeContactSubmissionMethods();
    schedulePinStyles();
    APPLY_DELAYS.forEach(function (delay) {
      window.setTimeout(customizeContactSubmissionMethods, delay);
    });
  }

  var observerTimer = null;

  function debouncedCustomize() {
    if (observerTimer) window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(function () {
      observerTimer = null;
      customizeContactSubmissionMethods();
    }, 50);
  }

  function bindSubmissionObserver() {
    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal || modal.dataset.ciwContactSubmissionObs === '1') return;
    modal.dataset.ciwContactSubmissionObs = '1';

    var observer = new MutationObserver(function () {
      debouncedCustomize();
    });

    observer.observe(modal, {
      childList: true,
      subtree: true
    });
  }

  function bind() {
    if (!isContactHost()) return;

    var events = [
      'LensAdvizor:component:DidMount',
      'LensAdvizor:selectLensModal:open',
      'LensAdvizor:render:submissionMethods'
    ];

    events.forEach(function (eventName) {
      document.addEventListener(eventName, scheduleCustomize);
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('.cl-la-trigger, lensadvizor-btn, .cl-la-slot lensadvizor-btn')) {
        window.setTimeout(scheduleCustomize, 300);
        window.setTimeout(scheduleCustomize, 800);
      }
    });

    bindSubmissionObserver();
    scheduleCustomize();
    schedulePinStyles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
